<div class="vBuilder-main no-sidebar">
  <div id="main-content">
    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12 center-block">
      <div class="row">
        <div class="col-sm-12 col-xs-12 col-md-4 col-lg-3">
          <div class="templates-list">
            <div class="add-catgory-Button">
              <a href="" data-bs-toggle="modal" (click)="openCategoryTempModal(null)" class="button-white"
                style="display: inline-flex;">
                <div class="category-margin">
                  <i class="material-icons" style="color: #32cdf1;">add_circle_outline</i>
                </div>
                <div>Add Category</div>
              </a>
            </div>
            <div class="category-name">
              <ul cdkDropList (cdkDropListDropped)="drop($event)" class="reorder-componant">
                <li class="heading" id="nosorting"> {{category?.name}} </li>
                @for (template of category?.vBuilderTemplates; track template; let i = $index) {
                  <li cdkDrag>
                    {{template.actionName}}
                    <i class="material-icons drag-handle pull-right hidden-sm hidden-xs poi" cdkDragHandle>
                      open_with
                    </i>
                    <i class="material-icons drag-handle pull-right" (click)="deleteTemplate(template.id)">
                      delete
                    </i>
                    <i class="material-icons drag-handle pull-right" (click)="openCategoryTempModal(template)">
                      create
                    </i>
                  </li>
                }
              </ul>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xs-12 col-md-8 col-lg-9">
          <div class="dashboard-content">
            <div>
              <div class="row" style="padding: 0px 15px 0px 0px;">
                <div #placeholder></div>
                <div class="col-12 col-sm-6 col-xl-4">
                  <div class="dashed-border-box" (click)="openPlaybookModal(null, 'Add')">
                    <a class="dashed-border-box-inner">
                      <i class="material-icons icon-50">control_point</i>
                      <span style="font-size: 25px;">Add a New Playbook</span>
                    </a>
                  </div>
                </div>
                @for (playbook of playbooks | orderBy:'order'; track playbook) {
                  <div class="col-12 col-sm-6 col-xl-4">
                    @if (playbook.contentNotification && !playbook.contentNotification.hasDismissed) {
                      <div class="notification-alert"
                        >
                        <i class="material-icons pointer" style="font-size: 20px;">
                          notifications
                        </i>
                      </div>
                    }
                    <div class="card acme-card" [ngClass]="{'drafted': playbook.isDraftMode == true}"
                      id="playbook-{{playbook.id}}">
                      <!-- Cover image -->
                      <div>
                        @if (!playbook.isPlaceHolderPlaybook) {
                          <div class="img-wrapper" (click)="goToPlaybook(playbook.id)"
                            [ngStyle]="{'background': playbook.coverAssetId ? '': '#d9d9d9'}">
                            @if (playbook.coverAssetId) {
                              <img onerror="this.src = 'assets/img/loader.gif'"
                                (load)="imageLoaded = true;" [hidden]="!imageLoaded" loading="lazy"
                          [src]=" '/api/Assets/Image/' + playbook.coverAssetId + '?height=240&ratio=' + devicePixelRatio | loadSecureAssets : true | async">
}
                        @if (!playbook.coverAssetId) {
<img loading="lazy" [src]="'assets/img/playstation-minimalism.jpg'">
}
                        @if (playbook.isDraftMode) {
<div class="edit-icon-circle">
                          <span class="material-icons edit-icon">edit</span>
                        </div>
}
                      </div>
}

                      @if (playbook.isPlaceHolderPlaybook) {
<div class="img-wrapper"
                        (click)="goToPlaybook(playbook.id, $event)"
                        [ngStyle]="{'background': playbook.coverAssetId ? '': '#d9d9d9'}">
                            @if (!playbook.coverAssetId) {
                              <img (load)="imageLoaded = true;" [hidden]="!imageLoaded"
                                [src]="'assets/img/loader.gif'">
                              }
                              @if (playbook.isDraftMode) {
                                <div class="edit-icon-circle">
                                  <span class="material-icons edit-icon">edit</span>
                                </div>
                              }
                            </div>
                          }
                        </div>
                        <!-- Playbook card body -->
                        <div class="card-body">
                          <div class="d-flex justify-content-between align-items-center">
                            <div (click)="goToPlaybook(playbook.id)" class="card-title-outer">
                              <a [routerLink]="['/playbook',playbook.id]" class="text-decoration-none pointer"
                                [queryParams]="{languageId: '1', r: 'vbuilder/category/detail/' + categoryId }">
                                <h5 class="card-title-inner" title="{{playbook.title}}">{{playbook.title}}</h5>
                              </a>
                              @if (playbook.lastUpdatedAt != null && playbook.lastUpdatedAt != '' ) {
                                <p class="card-text"
                                  title="Updated on {{playbook.lastUpdatedAt | date : 'MM/dd/yyyy'}}&nbsp;|&nbsp;Users:{{playbook.playbookUserCount || 0}}">
                                  <span>
                                    Last updated on {{playbook.lastUpdatedAt | date : "MM/dd/yyyy"}}
                                  </span>
                                </p>
                              }
                            </div>
                            <!-- Settings menu popup -->
                            <div>
                              <div class="btn-group v_cst-dropup dropup pb-list-settings">
                                <a (click)="currentPbId = playbook.id" data-bs-toggle="dropdown" data-bs-display="static" aria-haspopup="true"
                                  aria-expanded="false">
                                <i class="material-icons v_setting-icon">settings_applications</i>
                              </a>
                              <ul class="dropdown-menu playbook-setting-dropdown pointer">
                                <li>
                                  <a (click)="openPlaybookModal(playbook, 'Edit')">
                                    <i class="material-icons grey-icon-color">settings</i>
                                    <span class="gear-name">Playbook Settings</span>
                                  </a>
                                </li>
                                <li>
                                  <a (click)="openCoverAndColorsModal(playbook)">
                                    <i class="material-icons grey-icon-color">color_lens</i>
                                    <span class="gear-name">Cover & Colors</span>
                                  </a>
                                </li>
                                <li>
                                  <a (click)="openContentNotificationsModal(playbook)">
                                    <i class="material-icons grey-icon-color">add_alert</i>
                                    <span class="gear-name">Content Notifications</span>
                                  </a>
                                </li>
                                <li>
                                  <a (click)="openDuplicatePlaybookModal(playbook)">
                                    <i class="material-icons grey-icon-color">file_copy</i>
                                    <span class="gear-name">Duplicate Playbook</span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>